import { jsx as _jsx } from "react/jsx-runtime";
import { FieldWrapper, Select, } from '@dixa/lib-shared-habla';
import { useCallback, useState } from 'react';
import { useUpdateEffect } from 'react-use';
import { useHookFormFieldWrapper, } from 'utils/hookForm';
/**
 * Represents the React Hook Form variant of the {@link Select} component.
 *
 * @deprecated Use {@link HookFormSelectionList} instead.
 */
export const HookFormSelect = (props) => {
    var _a, _b, _c;
    const { controller, controllerProps, fieldWrapperProps } = useHookFormFieldWrapper(props);
    const [selectedItems, setSelectedItems] = useState(
    // Note that if `defaultValues` is set on `useForm`, the consumer of this
    // component has to set `selectedItems` manually seeing how we can not
    // extract that data from here.
    (_b = ((_a = controllerProps.defaultValue) !== null && _a !== void 0 ? _a : props.componentProps.selectedItems)) !== null && _b !== void 0 ? _b : []);
    /** Handles the item selection. */
    const handleChange = useCallback((item, isChecked) => {
        setSelectedItems(isChecked
            ? selectedItems.concat(item)
            : selectedItems.filter(({ id }) => id !== item.id));
    }, [selectedItems]);
    /** Handles selecting an single item. */
    const handleSelect = (item) => setSelectedItems([item]);
    /** Handles clearing the selected items. */
    const handleClear = () => setSelectedItems([]);
    // Handles calling React Hook Form change event because the select component
    // doesn't conform to what.
    useUpdateEffect(() => {
        var _a, _b, _c, _d;
        (_b = (_a = props.componentProps).onSelect) === null || _b === void 0 ? void 0 : _b.call(_a, selectedItems);
        (_d = (_c = props.componentProps).onChange) === null || _d === void 0 ? void 0 : _d.call(_c, selectedItems);
    }, [controller.field.onChange, selectedItems]);
    const meta = Object.assign(Object.assign({}, fieldWrapperProps.meta), { 
        // When the form is submitted without a selected item, the select component
        // stays unblurred and therefore untouched. The FieldWrapper and the
        // InputWrapper inside the Select don't accept a 'meta.error' message when
        // 'touched' is 'false'. Overwrite it here to be either 'true' or
        // 'undefined' fixes this. This way we get the alert message and the colored
        // border.
        touched: ((_c = fieldWrapperProps.meta) === null || _c === void 0 ? void 0 : _c.touched) ? true : undefined });
    return (_jsx(FieldWrapper, Object.assign({}, fieldWrapperProps, { meta: meta }, { children: _jsx(Select, Object.assign({}, props.componentProps, controller.field, { id: controllerProps.name, selectedItems: selectedItems, disabled: fieldWrapperProps.disabled, onChange: handleChange, onClear: handleClear, onSelect: handleSelect, status: FieldWrapper.getStatus(meta) })) })));
};
